export enum NEXT_ACTION_TYPES {
  DOWNLOAD_SUCCESS_UPSELL_ACTION = 'DOWNLOAD_SUCCESS_UPSELL_ACTION'
}
